module.exports = __webpack_public_path__ + "img/banner_bg_001.f353c2b.png";